import withSSRModel from "hoc-lib/ssrModelMapper"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import {
  onSuggestNoResults,
  setCustomerAddress,
  setPrimaryAddress,
  setHasGeosuggestion,
} from "actions-lib"
import { FacilitySearch as FacilitySearchComponent } from "./FacilitySearch"

export const mapDispatchToProps = (dispatch) => ({
  reduxActions: bindActionCreators(
    {
      setPrimaryAddress,
      setHasGeosuggestion,
      onSuggestNoResults,
      setCustomerAddress,
    },
    dispatch,
  ),
})

export const mapStateToProps = (state) => {
  const { customerSelections, siteAnalytics, siteLanguage, facilityLocator } =
    state

  return {
    reduxState: {
      customerSelections,
      siteAnalytics,
      siteLanguage,
      facilityLocator,
    },
  }
}

const WrappedComponent = withSSRModel(
  connect(mapStateToProps, mapDispatchToProps)(FacilitySearchComponent),
)

// Component has to be mapped by the consumer
// Config has to be imported from constants-lib and passed to the MapTo function by the consumer
export default WrappedComponent
